import React from "react";
import useObserverCallback from "../lib/hooks/useObserverCallback";
export const PRIMARY_HEADER_HEIGHT_CSS_VARIABLE = "--primary-header-height";
export const SECONDARY_HEADER_HEIGHT_CSS_VARIABLE = "--secondary-header-height";
export const BANNER_HEIGHT_CSS_VARIABLE = "--banner-height";
export const FAULT_EVENT_HEADER_HEIGHT_CSS_VARIABLE = "--fault-event-header-height";
export const FAULT_EVENT_NAVIGATION_HEIGHT_CSS_VARIABLE = "--fault-event-navigation-height";
export const FILTER_ACTIVITY_HEIGHT_CSS_VARIABLE = "--filter-activity-height";
export const FAULT_EVENT_SIDE_PANEL_HEIGHT_CSS_VARIABLE = "--side-panel-filter-activity-height";

type HeaderCssVariable =
  | typeof PRIMARY_HEADER_HEIGHT_CSS_VARIABLE
  | typeof SECONDARY_HEADER_HEIGHT_CSS_VARIABLE
  | typeof BANNER_HEIGHT_CSS_VARIABLE
  | typeof FAULT_EVENT_HEADER_HEIGHT_CSS_VARIABLE
  | typeof FILTER_ACTIVITY_HEIGHT_CSS_VARIABLE
  | typeof FAULT_EVENT_SIDE_PANEL_HEIGHT_CSS_VARIABLE
  | typeof FAULT_EVENT_NAVIGATION_HEIGHT_CSS_VARIABLE;

const useHeaderHeight = (
  headerRef: React.RefObject<HTMLElement>,
  cssVariable: HeaderCssVariable,
) => {
  const oldHeaderHeight = React.useRef(0);

  useObserverCallback(
    ({ target }) => {
      const hasProperty = cssVariable in document.documentElement.style;

      const height = target.offsetHeight;
      if (!hasProperty || oldHeaderHeight.current !== height) {
        window.requestAnimationFrame(() => {
          document.documentElement.style.setProperty(cssVariable, `${height}px`);
          oldHeaderHeight.current = height;
        });
      }
    },
    [cssVariable],
    headerRef,
    { fireOnInit: true, debounced: false },
  );

  React.useLayoutEffect(
    () => () => {
      document.documentElement.style.removeProperty(cssVariable);
    },
    [cssVariable],
  );
};

export default useHeaderHeight;
